(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-share-copy]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const url = btn.dataset.shareUrl || window.location.href;
        try {
          await navigator.clipboard.writeText(url);
          btn.classList.add('is-copied');
          setTimeout(() => btn.classList.remove('is-copied'), 1500);
        } catch (_) {
          // Fallback: select-and-copy via a hidden input.
          const tmp = document.createElement('input');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try {
            document.execCommand('copy');
          } catch (_) {}
          tmp.remove();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection]').forEach((root) => {
      // Mobile filter drawer toggle
      const toggle = root.querySelector('[data-filter-toggle]');
      const sidebar = root.querySelector('[data-collection-sidebar]');
      const closeBtns = root.querySelectorAll('[data-filter-close]');
      if (toggle && sidebar) {
        const backdrop = root.querySelector('.main-collection__sidebar-backdrop');
        const setOpen = (open) => {
          toggle.setAttribute('aria-expanded', String(open));
          sidebar.classList.toggle('is-open', open);
          backdrop?.classList.toggle('is-open', open);
          document.body.classList.toggle('collection-filters-open', open);
        };
        toggle.addEventListener('click', () => {
          setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        });
        closeBtns.forEach((btn) => btn.addEventListener('click', () => setOpen(false)));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && sidebar.classList.contains('is-open')) setOpen(false);
        });
      }

      // Sort: custom listbox dropdown. Clicking the button toggles the
      // menu; clicking an option sets the hidden input and submits the
      // form. Full keyboard support (Up/Down/Home/End/Enter/Esc) with
      // roving tabindex on the active option.
      const sortDropdown = root.querySelector('[data-sort-dropdown]');
      if (sortDropdown) {
        const trigger = sortDropdown.querySelector('[data-sort-button]');
        const menu = sortDropdown.querySelector('[data-sort-menu]');
        const currentLabel = sortDropdown.querySelector('[data-sort-current]');
        const hiddenInput = sortDropdown.querySelector('[data-collection-sort]');
        const options = Array.from(sortDropdown.querySelectorAll('[data-sort-option]'));
        const form = sortDropdown.closest('form');

        // Track the visually-focused option index for keyboard nav. We do
        // not move DOM focus per-option (the menu container holds focus)
        // — we move tabindex+aria so AT announces the active option.
        let activeIndex = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        if (activeIndex < 0) activeIndex = 0;

        const setActive = (idx) => {
          activeIndex = (idx + options.length) % options.length;
          options.forEach((opt, i) => {
            const active = i === activeIndex;
            opt.classList.toggle('is-active', active);
            opt.setAttribute('tabindex', active ? '0' : '-1');
          });
          options[activeIndex]?.focus();
        };

        const openMenu = () => {
          if (trigger.getAttribute('aria-expanded') === 'true') return;
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          sortDropdown.classList.add('is-open');
          // Reset highlight to the currently-selected option so keyboard
          // users start where the visible state implies.
          const selectedIdx = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
          setActive(selectedIdx >= 0 ? selectedIdx : 0);
        };

        const closeMenu = ({ returnFocus = true } = {}) => {
          if (trigger.getAttribute('aria-expanded') !== 'true') return;
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          sortDropdown.classList.remove('is-open');
          if (returnFocus) trigger.focus();
        };

        const selectOption = (opt) => {
          if (!opt || !hiddenInput) return;
          const value = opt.dataset.value;
          if (!value || hiddenInput.value === value) {
            closeMenu();
            return;
          }
          hiddenInput.value = value;
          options.forEach((o) => {
            const isMatch = o === opt;
            o.classList.toggle('is-selected', isMatch);
            o.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          });
          if (currentLabel) currentLabel.textContent = opt.textContent.trim();
          closeMenu({ returnFocus: false });
          form?.submit();
        };

        trigger.addEventListener('click', () => {
          if (trigger.getAttribute('aria-expanded') === 'true') closeMenu();
          else openMenu();
        });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openMenu();
          }
        });

        menu.addEventListener('click', (e) => {
          const opt = e.target.closest('[data-sort-option]');
          if (opt) selectOption(opt);
        });

        menu.addEventListener('keydown', (e) => {
          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              setActive(activeIndex + 1);
              break;
            case 'ArrowUp':
              e.preventDefault();
              setActive(activeIndex - 1);
              break;
            case 'Home':
              e.preventDefault();
              setActive(0);
              break;
            case 'End':
              e.preventDefault();
              setActive(options.length - 1);
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              selectOption(options[activeIndex]);
              break;
            case 'Escape':
              e.preventDefault();
              closeMenu();
              break;
            case 'Tab':
              closeMenu({ returnFocus: false });
              break;
          }
        });

        // Outside click closes the menu.
        document.addEventListener('click', (e) => {
          if (!sortDropdown.contains(e.target)) closeMenu({ returnFocus: false });
        });
      }

      // Filter checkboxes: any change submits the filters form.
      // Replaces the inline `onchange='document.getElementById("FiltersForm").submit()'` handler.
      const filtersForm = root.querySelector('#FiltersForm');
      if (filtersForm) {
        filtersForm.addEventListener('change', (e) => {
          const input = e.target;
          if (input && input.matches('[data-filter-input]')) {
            filtersForm.submit();
          }
        });
      }

      // Show-more: reveal items past the 6th. The list is capped via CSS
      // nth-child rules; `.is-expanded` lifts the cap.
      root.querySelectorAll('[data-filter-show-more]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.closest('.filters__group') || btn.parentElement;
          const list = group?.querySelector('[data-filter-list]');
          if (!list) return;
          const expanded = list.classList.toggle('is-expanded');
          btn.classList.toggle('is-expanded', expanded);
          const label = btn.querySelector('[data-show-more-label]');
          if (label) {
            const on = label.dataset.showMoreOn || 'Prikaži manje';
            const off = label.dataset.showMoreOff || 'Prikaži više';
            label.textContent = expanded ? on : off;
          }
        });
      });

      // Dual-thumb price slider: update visual fill on input + submit on release
      root.querySelectorAll('[data-price-slider]').forEach((slider) => {
        const minInput = slider.querySelector('[data-price-input-min]');
        const maxInput = slider.querySelector('[data-price-input-max]');
        const range = slider.querySelector('[data-price-range]');
        const thumbMin = slider.querySelector('[data-price-thumb-min]');
        const thumbMax = slider.querySelector('[data-price-thumb-max]');
        const labelMin = slider.querySelector('[data-price-label-min]');
        const labelMax = slider.querySelector('[data-price-label-max]');
        if (!minInput || !maxInput) return;

        const minBound = Number(slider.dataset.priceMin);
        const maxBound = Number(slider.dataset.priceMax);
        const span = maxBound - minBound;

        const update = () => {
          let lo = Number(minInput.value);
          let hi = Number(maxInput.value);
          if (lo > hi) [lo, hi] = [hi, lo];
          const loPct = ((lo - minBound) / span) * 100;
          const hiPct = ((hi - minBound) / span) * 100;
          if (range) {
            range.style.left = loPct + '%';
            range.style.right = 100 - hiPct + '%';
          }
          if (thumbMin) thumbMin.style.left = loPct + '%';
          if (thumbMax) thumbMax.style.left = hiPct + '%';
          if (labelMin) labelMin.textContent = lo.toFixed(2).replace('.', ',') + ' €';
          if (labelMax) labelMax.textContent = hi.toFixed(2).replace('.', ',') + ' €';
        };

        const submit = () => {
          // Clamp crossed values before submitting so the URL params make sense.
          let lo = Number(minInput.value);
          let hi = Number(maxInput.value);
          if (lo > hi) {
            minInput.value = hi;
            maxInput.value = lo;
          }
          document.getElementById('FiltersForm')?.submit();
        };

        minInput.addEventListener('input', update);
        maxInput.addEventListener('input', update);
        minInput.addEventListener('change', submit);
        maxInput.addEventListener('change', submit);
        update();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Copy-link share button (replaces the old dead Instagram link). Mirrors the
  // handler in main-article.liquid; kept section-local so it only ships on PDPs.
  document.querySelectorAll('[data-share-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.shareUrl || window.location.href;
      try {
        await navigator.clipboard.writeText(url);
      } catch (_) {
        const tmp = document.createElement('input');
        tmp.value = url;
        document.body.appendChild(tmp);
        tmp.select();
        try {
          document.execCommand('copy');
        } catch (_) {}
        tmp.remove();
      }
      btn.classList.add('is-copied');
      setTimeout(() => btn.classList.remove('is-copied'), 1500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    // Always fetch the recommendations URL — that's what triggers Shopify's
    // ML to compute personalized picks. The server-side render falls back to
    // the chosen collection if ML returns nothing.
    document.querySelectorAll('[data-product-recommendations]').forEach((root) => {
      const url = root.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-tabs]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-tab-target]'));
      const panels = root.querySelectorAll('[data-tab-panel]');

      const activate = (tab) => {
        const target = tab.dataset.tabTarget;
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((p) => {
          const active = p.dataset.tabPanel === target;
          p.classList.toggle('is-active', active);
          if (active) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      };

      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activate(tab));

        // Roving tabindex / arrow-key nav per WAI-ARIA tabs pattern.
        // ArrowLeft/Right wrap at edges. Home / End jump to first / last.
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            activate(next);
            next.focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
